<template>
  <v-card flat>
    <v-card-title class="mb-1">
      {{ SStructType.name }}
    </v-card-title>
    <v-card-subtitle>
      {{ SStructType.description }}
    </v-card-subtitle>
  </v-card>
</template>

<script>
/***
 * presentation of info about the type of speech struct
 *
 * @description use with prop {Object} SStructType - type of speech struct
 */
export default {
  name: 'SStructTypeInfo',
  props: {
    SStructType: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
